import axios from 'axios';

export const startTavusConversation = async () => {
  try {
    const response = await axios.post('https://zenith-tavus.onrender.com/api/tavus-proxy', {
      replica_id: 'r4317e64d25a',
      persona_id: 'pf1a99a1576c',
    });
    return response.data;
  } catch (err) {
    const error = err as any;
    if (error.response && error.response.data && error.response.data.error) {
      throw new Error(
        typeof error.response.data.error === 'string'
          ? error.response.data.error
          : JSON.stringify(error.response.data.error)
      );
    }
    throw error;
  }
};

export const endTavusConversation = async (conversation_id: string) => {
  try {
    const response = await axios.post('https://zenith-tavus.onrender.com/api/tavus-end-conversation', {
      conversation_id,
    });
    return response.data;
  } catch (err) {
    const error = err as any;
    if (error.response && error.response.data && error.response.data.error) {
      throw new Error(
        typeof error.response.data.error === 'string'
          ? error.response.data.error
          : JSON.stringify(error.response.data.error)
      );
    }
    throw error;
  }
}; 